<div class="container">
  <div class="row">
    <div class="col folat-start">
      <h3>{{patent_name}}</h3>
    </div>
    <div class="col folat-end"></div>
  </div>
  <br>
    <div class="row">
      <div class="col-12 table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr class="header-color" class="table-secondary">
              <th>#</th>
              <th>Title</th>
              <th>Note Description</th>
              <th>Seen by</th>
              <th>Created Date</th>
              <th>Updated Date</th>
            </tr>
          </thead>
          <tbody>
            @if (list_length == 0) {
              <tr>
                <td colspan="7">No data found</td>
              </tr>
            }
            @for (item of items | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; track item; let i = $index) {
              <tr
                [class]="item?.Package_Patient?.no_sessions_took==item?.Package_Patient?.no_sessions? 'green_bold' : ''">
                <td>{{ ((page-1) * pageSize) + (i+1) }}</td>
                <td align="left">
                  <span style="cursor: pointer;"
                  (click)="open(content2, item?.description)">{{item?.title}}</span>
                </td>
                <td class="d-inline-block text-truncate" style="max-width: 600px;">
                  {{item?.description}}
                </td>
                <td>
                  {{getDoctor(item?.doctor_id)}}
                </td>
                <td>{{item?.created_at | date: 'dd/MM/yyyy'}}</td>
                <td>{{item?.updated_at | date: 'dd/MM/yyyy'}}</td>
              </tr>
            }
          </tbody>
        </table>
        <ngb-pagination [collectionSize]="items.length" [(page)]="page" [maxSize]="5" [rotate]="true"
        [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
      </div>
    </div>
  </div>

  <ng-template #content2 let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Note Details</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <textarea class="form-control" id="notes" rows="10" cols="50" [(ngModel)]="description" [disabled]="true" ></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="close()">Ok</button>
    </div>
  </ng-template>